import { render } from "./OpenSourceProjects.vue?vue&type=template&id=4d5773ee&scoped=true"
import script from "./OpenSourceProjects.vue?vue&type=script&lang=js"
export * from "./OpenSourceProjects.vue?vue&type=script&lang=js"

import "./OpenSourceProjects.vue?vue&type=style&index=0&id=4d5773ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5773ee"]])

export default __exports__